import Vue from 'vue';
import rmdyAuth from '@rmdy/rmdy-authentication-frontend';
import rmdyTranslations from '@rmdy/rmdy-translations-frontend';
import App from './app.vue';
import router from './config/router';
import store from './store';
import vuetify from './plugins/vuetify';
import backendApi from './services/backendApi';
import locales from './locales/languages';

Vue.config.productionTip = false;

Vue.use(rmdyAuth, {
	store,
	backendApi,
	router,
	options: {
		logOutAction: undefined,
		google: true,
		local: false,
	}
});

Vue.use(rmdyTranslations, {
	backendApi,
	languageFile: locales,
	options: {}
});

new Vue({
	router,
	store,
	i18n: rmdyTranslations.i18n,
	vuetify,
	render: h => h(App)
}).$mount('#app');
